import styles from '@components/components/CmsComponents/components/CmsSiteEndComponent/CmsSiteEndComponent.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import { Content, Heading } from '@wienenergiegithub/ui-next';

const CmsSiteEndComponent = ({ title, content }) => (
  <aside aria-label={title} className={styles.container}>
    <div className={styles.main}>
      <Heading size="h5">{title}</Heading>
      <Content size="regular">{content}</Content>
    </div>
  </aside>
);

CmsSiteEndComponent.propTypes = {
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CmsSiteEndComponent;
